import React from "react";
import ProductCard from "../components/ProductCard";

export default function GridProducts({
                                         products,
                                         cardStyleClass,
                                         tooltipDirection = "up",
                                     }) {

    return (
        <>
            {products.map((product, i) => (
                <ProductCard
                    key={i}
                    product={product}
                    styleClass={cardStyleClass ? cardStyleClass : "grid style-2"}
                    tooltipDirection={tooltipDirection}
                />
            ))}
        </>
    );
}
